import Papa from 'papaparse'
import { useEffect, useState } from 'react'

export * from './generateRandomArray'
export * from './vibrancyUtils'
export * from './tableViewUtils'

export function useDataWithMetric(csvPath: string) {
  const [data, setData] = useState<any[] | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!csvPath) {
      setData(null)
      setLoading(false)
      setError(null)
      return
    }

    const controller = new AbortController()
    const { signal } = controller
    let mounted = true

    async function getData() {
      setLoading(true)
      setError(null)
      try {
        const response = await fetch(csvPath, { signal })
        if (!response.ok) {
          throw new Error(`Failed to fetch ${csvPath}: ${response.status} ${response.statusText}`)
        }

        // read entire body to avoid partial/chunked reads
        const csvText = await response.text()

        if (!mounted) return
        const results = Papa.parse(csvText, { header: true }) // object with { data, errors, meta }
        const rows = results.data as any[]
        setData(rows)
      } catch (err: any) {
        if (err?.name === 'AbortError') return
        console.error('useDataWithMetric error', err)
        if (mounted) setError(err)
        setData(null)
      } finally {
        if (mounted) setLoading(false)
      }
    }

    getData()

    return () => {
      mounted = false
      controller.abort()
    }
  }, [csvPath])

  return { data, loading, error }
}

export const calculateStringWidth = (stringParam: string, font: string): number => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  context!.font = font

  return context!.measureText(stringParam).width
}
